import { errors } from '../../services/ruutsApi/errors'

export const siteConflictMessage = ({ site, error }) =>
  error?.response?.conflictType === 'siteNameCollision'
    ? `Ya existe un sitio de monitoreo llamado "${
        error.response.existingSite?.name ?? site.properties.name
      }" en este establecimiento.`
    : null

// The snackbar/dialog show a business error's own message and drop the custom text, so the
// wording the user must read has to travel as the error's message.
export const withDisplayMessage = (error, message) =>
  error instanceof errors.RuutsError && !error.unexpected
    ? new errors.BusinessEntityError({ message, response: error.response, needSupport: false })
    : error
